__turbopack_context__.v({
  "accordion": "home-faq-module__2oxg1G__accordion",
  "answer": "home-faq-module__2oxg1G__answer",
  "brandLtr": "home-faq-module__2oxg1G__brandLtr",
  "content": "home-faq-module__2oxg1G__content",
  "faqSlideDown": "home-faq-module__2oxg1G__faqSlideDown",
  "faqSlideUp": "home-faq-module__2oxg1G__faqSlideUp",
  "header": "home-faq-module__2oxg1G__header",
  "icon": "home-faq-module__2oxg1G__icon",
  "item": "home-faq-module__2oxg1G__item",
  "plus": "home-faq-module__2oxg1G__plus",
  "question": "home-faq-module__2oxg1G__question",
  "section": "home-faq-module__2oxg1G__section",
  "srOnly": "home-faq-module__2oxg1G__srOnly",
  "trigger": "home-faq-module__2oxg1G__trigger",
});
